import React from 'react';
export const Banner = () => {
  return <div className="w-full bg-gray-200 py-2 text-center text-sm text-gray-600" data-id="element-141">
      Advertorial
    </div>;
};